import { z } from 'zod';
import { TimelineSlot, WidgetType, ZodBaseWidgetConfiguration } from '../../types';
import { BaseThirdPartyAd, ZodBaseThirdPartyAdWidgetConfigurationDetails } from '../types';
import { VengoWidget } from './VengoWidget';
import { zMarshalToBoolean } from '../../../ReachApi/Marshallers';

export enum VengoBaseUrls {
    STAGING = 'https://staging-pubads.vengolabs.com',
    PRODUCTION = 'https://pubads.vengolabs.com',
}

export type VengoAd = BaseThirdPartyAd & {
    popUrl: string;
};

export type VengoWidgetTimelineSlotParams = {
    ad: VengoAd;
};

export type VengoWidgetTimelineSlot = TimelineSlot<VengoWidgetTimelineSlotParams, VengoWidget>;

export const ZodVengoWidgetConfigurationDetails =
    ZodBaseThirdPartyAdWidgetConfigurationDetails.extend({
        is_test: z.unknown().transform(zMarshalToBoolean),
    });

export type VengoWidgetConfigurationDetails = z.infer<typeof ZodVengoWidgetConfigurationDetails>;

export const ZodVengoWidgetConfiguration = ZodBaseWidgetConfiguration.extend({
    type: z.literal(WidgetType.VENGO),
    config: ZodVengoWidgetConfigurationDetails,
});

export type VengoWidgetConfiguration = z.infer<typeof ZodVengoWidgetConfiguration>;
